import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EElasticLogLevel, ElasticLogModel } from './log.model';

export interface IPublisher {
  log(record: ElasticLogModel, level?: EElasticLogLevel): void;

  location?: string;
}

export class ConsolePublisher implements IPublisher {
  log(entry: ElasticLogModel): void {
    const message: unknown = JSON.parse(entry.Message);
    switch (entry.Level) {
      case EElasticLogLevel.Debug:
        console.debug(message);
        break;
      case EElasticLogLevel.Info:
        console.info(message);
        break;
      case EElasticLogLevel.Warn:
        console.warn(message);
        break;
      case EElasticLogLevel.Error:
        console.error(message);
        break;
      default:
        console.log(message);
    }
  }
}

export class WebPublisher implements IPublisher {
  location = environment.log_endpoint;

  constructor(private http: HttpClient) {}

  log(entry: ElasticLogModel): void {
    void this.http.post<void>(this.location, entry).toPromise();
  }
}
